var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgText13(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 52,
    viewBox: "0 0 43 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 3004"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3072"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.9,
    d: "M13.9457 4.27344C20.6996 4.27344 25.8129 9.74219 26.852 18.6562H34.7817V0.828125H42.5473V51.1406H34.7817V24.8906H26.9613C26.141 34.4609 20.9184 40.3125 13.9457 40.3125C6.23478 40.3125 0.71134 33.3672 0.766028 22.2109C0.71134 11.2188 6.23478 4.27344 13.9457 4.27344ZM13.9457 11.3828C10.6098 11.3828 8.25821 15.0469 8.3129 22.2109C8.25821 29.4844 10.6098 33.1484 13.9457 33.1484C17.391 33.1484 19.5785 29.4844 19.5785 22.2109C19.5785 15.0469 17.391 11.3828 13.9457 11.3828Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText13);
export default __webpack_public_path__ + "static/media/text13.8d465dfafd1a300772ed76e075632f05.svg";
export { ForwardRef as ReactComponent };